import { REQUEST, SUCCESS, ERROR, ROOT } from './types'
import * as suitPayload from '../../utils/helpers/payloadSuit/drivers'
import { buildQuery } from "../../utils/buildQuery";

const state = {
  data: {
    current: {},
    list: {},
    created: {},
    edited: {},
  },
  loading: false,
  error: false,
}

const getters = {
  current: (state) => state.data.current,
  list: (state) => state.data.list,
  created: (state) => state.data.created,
  edited: (state) => state.data.edited,
  trucker: (state) => state.data.trucker,
  loading: (state) => state.loading,
  error: (state) => state.error,
}

const actions = {
  async setCurrent(context, _id) {
    try {
      context.commit(REQUEST)

      if (!_id)
        throw new Error(`Erro: id não fornecido para buscar o motorista`)

      const response = await context.dispatch(
        `api`,
        {
          entity: `drivers`,
          action: `get`,
          query: `/${_id}`,
        },
        ROOT
      )

      const { data, status } = response

      if (status !== 200) throw response

      context.commit(SUCCESS, { key: `current`, data })
      return
    } catch (err) {
      console.error(err)
      const message =
        err.data?.error ||
        err.data?.errors ||
        `Ocorreu um erro ao selecionar o motorista, por favor tente novamente.`

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message,
          color: `error`,
        },
        ROOT
      )

      return context.commit(ERROR)
    }
  },

  async setList(context, { filters, pagination }) {
    try {
      context.commit(REQUEST)

      const { page, perPage, sortField, sortDirection } = pagination
      
      const query = {
        page: page || 1,
        per_page: perPage || 15,
        sort_field: sortField || ``,
        sort_direction: sortDirection || ``,
        checkCNH: filters.cnhStatus || ``,
        status: filters.status?.filter?.(item => ![`in_delivery`, `fidelizados`].includes(item)),
        favorite: filters.status.includes(`fidelizados`) || ``,
        in_delivery: filters.status.includes(`in_delivery`) || ``,
        initial_date: filters.dates?.[0] && filters.dates[0].split('-').reverse().join('-'),
        final_date: filters.dates?.[1] && filters.dates[1].split('-').reverse().join('-'),
        search: filters.search || ``,
        type_bond: filters.type_bond,
        dddOptions: filters.dddSelect ? filters.dddSelect.join(',') : ``,
        sourceSelect: filters.sourceSelect ? filters.sourceSelect.join(',') : ``,
        uf: filters.preference_region.toString()
      }

      const response = await context.dispatch(
        `api`,
        {
          entity: `drivers`,
          action: `get`,
          query: buildQuery(query),
        },
        ROOT
      )

      const { data, status } = response

      if (status !== 200) throw response

      return context.commit(SUCCESS, { key: `list`, data })
    } catch (err) {
      console.error(err)
      const message =
        err.data?.error ||
        err.data?.errors ||
        `Ocorreu um erro ao buscar os motoristas, por favor tente novamente.`

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message,
          color: `error`,
        },
        ROOT
      )

      return context.commit(ERROR)
    }
  },

  async setCreated(context, payload) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `drivers`,
          action: `post`,
          payload: suitPayload.create(payload),
        },
        ROOT
      )

      const { data, status } = response

      if (status !== 200) throw response

      return context.commit(SUCCESS, { key: `created`, data: data })
    } catch (err) {
      console.error(err)
      const message =
        err.data?.error ||
        err.data?.errors ||
        `Ocorreu um erro ao criar motorista, por favor tente novamente.`

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message,
          color: `error`,
        },
        ROOT
      )

      return context.commit(ERROR)
    }
  },

  async setEdited(context, payload) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `drivers`,
          action: `put`,
          payload: suitPayload.edit(payload),
        },
        ROOT
      )

      const { data, status } = response

      if (status !== 200) throw response

      return context.commit(SUCCESS, { key: `edited`, data: data })
    } catch (err) {
      console.error(err)
      const message =
        err.data?.error ||
        err.data?.errors ||
        `Ocorreu um erro ao editar motorista, por favor tente novamente.`

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message,
          color: `error`,
        },
        ROOT
      )

      return context.commit(ERROR)
    }
  },

  async setStatus(context, params) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `drivers`,
          action: `switchStatus`,
          params,
          payload: params.payload
        },
        { root: true }
      )

      const { status } = response

      if (status !== 204) throw response

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message: `Alteração de status realizada com sucesso!`,
          color: `success`,
        },
        ROOT
      )

      return context.commit(SUCCESS)
    } catch (err) {
      console.error(err)

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message: `Ocorreu um erro ao alterar o status do motorista, por favor tente novamente.`,
          color: `error`,
        },
        ROOT
      )

      context.commit(ERROR)
    }
  },

  async setTrucker(context, payload) {
    try {
      context.commit(REQUEST)

      const response = await context.dispatch(
        `api`,
        {
          entity: `share`,
          action: `post`,
          payload,
        },
        ROOT
      )

      if (response.status !== 204) throw response

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message: `Solicitação de integração realizada com sucesso!`,
          color: `success`,
        },
        ROOT
      )

      return context.commit(SUCCESS, null)
    } catch (err) {
      console.error(err)

      const message =
        err.data?.error ||
        err.data?.errors ||
        `Ocorreu um erro ao integrar o motorista com o trucker, por favor tente novamente.`

      context.dispatch(
        `App/setSnackbar`,
        {
          status: true,
          message,
          color: `error`,
        },
        ROOT
      )

      return context.commit(ERROR)
    }
  },
}

const mutations = {
  [REQUEST](state) {
    state.loading = true
  },
  [SUCCESS](state, payload) {
    if (payload) {
      state.data[payload.key] = payload.data
    }
    state.loading = false
    state.error = false
  },
  [ERROR](state) {
    state.loading = false
    state.error = true
  },
}

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
}
